import grow2529DetailsFakeFeatures from '~pricing/experiments/grow_2529_forms/transformers/details/fakeFeatures';

export default [...grow2529DetailsFakeFeatures];
